"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// .style-dictionary-output/nomad-spark/index.ts
var nomad_spark_exports = {};
__export(nomad_spark_exports, {
  default: () => nomad_spark_default
});
module.exports = __toCommonJS(nomad_spark_exports);
var theme = {
  "meta": {
    "font": {
      "dmsansRegular": {
        "filePath": "fonts/DMSans-Regular",
        "family": "DMSans-Regular",
        "weight": "400"
      },
      "dmsansRegularItalic": {
        "filePath": "fonts/DMSans-RegularItalic",
        "family": "DMSans-RegularItalic",
        "weight": "400",
        "style": "italic"
      },
      "dmsansMedium": {
        "filePath": "fonts/DMSans-Medium",
        "family": "DMSans-Medium",
        "weight": "500"
      },
      "dmsansMediumItalic": {
        "filePath": "fonts/DMSans-MediumItalic",
        "family": "DMSans-MediumItalic",
        "weight": "500",
        "style": "italic"
      },
      "dmsansBold": {
        "filePath": "fonts/DMSans-Bold",
        "family": "DMSans-Bold",
        "weight": "900"
      },
      "dmsansBoldItalic": {
        "filePath": "fonts/DMSans-BoldItalic",
        "family": "DMSans-BoldItalic",
        "weight": "900",
        "style": "italic"
      },
      "romekRoundedRegular": {
        "filePath": "fonts/RomekRounded-Regular",
        "family": "RomekRounded-Regular",
        "weight": "400"
      },
      "romekRoundedRegularItalic": {
        "filePath": "fonts/RomekRounded-RegularItalic",
        "family": "RomekRounded-RegularItalic",
        "weight": "400",
        "style": "italic"
      },
      "romekRoundedLight": {
        "filePath": "fonts/RomekRounded-Light",
        "family": "RomekRounded-Light",
        "weight": "300"
      },
      "romekRoundedLightItalic": {
        "filePath": "fonts/RomekRounded-LightItalic",
        "family": "RomekRounded-LightItalic",
        "weight": "300",
        "style": "italic"
      },
      "romekRoundedBold": {
        "filePath": "fonts/RomekRounded-Bold",
        "family": "RomekRounded-Bold",
        "weight": "900"
      },
      "romekRoundedBoldItalic": {
        "filePath": "fonts/RomekRounded-BoldItalic",
        "family": "RomekRounded-BoldItalic",
        "weight": "900",
        "style": "italic"
      }
    }
  },
  "base": {
    "breakpoints": {
      "xs": "0px",
      "sm": "600px",
      "md": "900px",
      "lg": "1200px",
      "xl": "1536px"
    },
    "color": {
      "backgroundDefault": "#ffffff",
      "textPrimary": "#000000",
      "textSecondary": "#ff4007",
      "textDisabled": "#b3b3b3",
      "divider": "#dee2ff",
      "focusRing": "#3facfb",
      "primary": "#ff4007",
      "primaryLight": "#ffe2dc",
      "primaryDark": "#d23000",
      "primaryContrastText": "#ffffff",
      "secondary": "#000000",
      "secondaryLight": "#b3b3b3",
      "secondaryDark": "#4d4d4d",
      "secondaryContrastText": "#ffffff",
      "error": "#bd0505",
      "errorLight": "#fff5f3",
      "errorDark": "#bd0505",
      "errorContrastText": "#000000",
      "warning": "#4200cf",
      "warningLight": "#f8f8ff",
      "warningDark": "#dee2ff",
      "warningContrastText": "#000000",
      "info": "#212962",
      "infoLight": "#f5fbff",
      "infoDark": "#d5f0ff",
      "infoContrastText": "#000000",
      "success": "#489900",
      "successLight": "#f5ffec",
      "successDark": "#cff0b2",
      "successContrastText": "#000000",
      "grey50": "#f9f9f9",
      "grey100": "#e5e5e5",
      "grey200": "#e5e5e5",
      "grey300": "#b3b3b3",
      "grey400": "#b3b3b3",
      "grey500": "#808080",
      "grey600": "#6d6d6d",
      "grey700": "#6d6d6d",
      "grey800": "#4d4d4d",
      "grey900": "#4d4d4d"
    },
    "shape": {
      "focusRingBorderRadius": "4px"
    },
    "spacing": {
      "focusRingOffset": "2px"
    },
    "typography": {
      "display1": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "120px",
        "fontWeight": 300,
        "lineHeight": 1.3,
        "letterSpacing": "-3.6px",
        "textTransform": "none"
      },
      "display2": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "80px",
        "fontWeight": 300,
        "lineHeight": 1.2,
        "letterSpacing": "-2.4px",
        "textTransform": "none"
      },
      "display3": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "64px",
        "fontWeight": 300,
        "lineHeight": 1.3,
        "letterSpacing": "-1.92px",
        "textTransform": "none"
      },
      "heading1": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "48px",
        "fontWeight": 300,
        "lineHeight": 1.3,
        "letterSpacing": "-0.96px",
        "textTransform": "none"
      },
      "heading2": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "40px",
        "fontWeight": 300,
        "lineHeight": 1.2,
        "letterSpacing": "-0.4px",
        "textTransform": "none"
      },
      "heading3": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "32px",
        "fontWeight": 300,
        "lineHeight": 1.2,
        "letterSpacing": "-0.32px",
        "textTransform": "none"
      },
      "heading3Highlight": {
        "fontFamily": "RomekRounded-RegularItalic, serif",
        "fontSize": "32px",
        "fontWeight": 400,
        "lineHeight": 1.3,
        "letterSpacing": "-0.64px",
        "textTransform": "none"
      },
      "heading4": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "24px",
        "fontWeight": 700,
        "lineHeight": 1.3,
        "letterSpacing": "0.06px",
        "textTransform": "none"
      },
      "heading5": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "24px",
        "fontWeight": 300,
        "lineHeight": 1.2,
        "letterSpacing": "-0.24px",
        "textTransform": "none"
      },
      "heading6": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "20px",
        "fontWeight": 500,
        "lineHeight": 1.3,
        "letterSpacing": "0.05px",
        "textTransform": "none"
      },
      "subtitle1": {
        "fontFamily": "RomekRounded-Light, serif",
        "fontSize": "18px",
        "fontWeight": 300,
        "lineHeight": 1.3,
        "letterSpacing": "0.045px",
        "textTransform": "none"
      },
      "subtitle2": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "16px",
        "fontWeight": 700,
        "lineHeight": 1.3,
        "letterSpacing": "0.03px",
        "textTransform": "none"
      },
      "subtitle3": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "12px",
        "fontWeight": 700,
        "lineHeight": 1.3,
        "letterSpacing": "0.03px",
        "textTransform": "none"
      },
      "subtitle4": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "12px",
        "fontWeight": 500,
        "lineHeight": 1.3,
        "letterSpacing": "0.06px",
        "textTransform": "uppercase"
      },
      "subtitle5": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "12px",
        "fontWeight": 500,
        "lineHeight": 1.3,
        "letterSpacing": "0.15px",
        "textTransform": "none"
      },
      "subtitle6": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "10px",
        "fontWeight": 700,
        "lineHeight": 1,
        "letterSpacing": "0.3px",
        "textTransform": "uppercase"
      },
      "body1": {
        "fontFamily": "DMSans-Regular, sans-serif",
        "fontSize": "20px",
        "fontWeight": 400,
        "lineHeight": 1.6,
        "letterSpacing": "0.1px",
        "textTransform": "none"
      },
      "body2": {
        "fontFamily": "DMSans-Regular, sans-serif",
        "fontSize": "16px",
        "fontWeight": 400,
        "lineHeight": 1.4,
        "letterSpacing": "0.8px",
        "textTransform": "none"
      },
      "body3": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "14px",
        "fontWeight": 500,
        "lineHeight": 1.3,
        "letterSpacing": "0.035px",
        "textTransform": "none"
      },
      "body3Light": {
        "fontFamily": "DMSans-Regular, sans-serif",
        "fontSize": "14px",
        "fontWeight": 400,
        "lineHeight": 1.3,
        "letterSpacing": "0.035px",
        "textTransform": "none"
      },
      "body4": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "12px",
        "fontWeight": 500,
        "lineHeight": 1.3,
        "letterSpacing": "0.03px",
        "textTransform": "none"
      },
      "body5": {
        "fontFamily": "DMSans-Regular, sans-serif",
        "fontSize": "12px",
        "fontWeight": 400,
        "lineHeight": 1.3,
        "letterSpacing": "0.03px",
        "textTransform": "none"
      },
      "eyebrow1": {
        "fontFamily": "DMSans-Regular, sans-serif",
        "fontSize": "18px",
        "fontWeight": 400,
        "lineHeight": 1.3,
        "letterSpacing": "0.045px",
        "textTransform": "uppercase"
      },
      "eyebrow2": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "12px",
        "fontWeight": 500,
        "lineHeight": 1.3,
        "letterSpacing": "0.03px",
        "textTransform": "none"
      },
      "eyebrow3": {
        "fontFamily": "DMSans-Regular, sans-serif",
        "fontSize": "12px",
        "fontWeight": 400,
        "lineHeight": 1.3,
        "letterSpacing": "0.03px",
        "textTransform": "uppercase"
      },
      "button1": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "20px",
        "fontWeight": 700,
        "lineHeight": 1,
        "letterSpacing": "0.35px",
        "textTransform": "none"
      },
      "button2": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "18px",
        "fontWeight": 700,
        "lineHeight": 1,
        "letterSpacing": "0.054px",
        "textTransform": "none"
      },
      "button2Primary": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "19px",
        "fontWeight": 700,
        "lineHeight": 1,
        "letterSpacing": "0.057px",
        "textTransform": "none"
      },
      "button3": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "16px",
        "fontWeight": 700,
        "lineHeight": 1,
        "letterSpacing": "0px",
        "textTransform": "none"
      },
      "button4": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "14px",
        "fontWeight": 700,
        "lineHeight": 1,
        "letterSpacing": "0px",
        "textTransform": "none"
      },
      "menu1": {
        "fontFamily": "DMSans-Bold, sans-serif",
        "fontSize": "19px",
        "fontWeight": 700,
        "lineHeight": 1.1,
        "letterSpacing": "0.057px",
        "textTransform": "none"
      },
      "menu2": {
        "fontFamily": "DMSans-Medium, sans-serif",
        "fontSize": "14px",
        "fontWeight": 500,
        "lineHeight": 1.1,
        "letterSpacing": "0.07px",
        "textTransform": "none"
      }
    }
  },
  "component": {
    "autocomplete": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "paddingBottom": "1px",
            "paddingTop": "15px",
            "paddingLeft": "24px"
          }
        }
      }
    },
    "badge": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#4200cf",
            "color": "#ffffff"
          }
        }
      },
      "pill": {
        "defaultSize": {
          "defaultState": {
            "height": "24px",
            "width": "24px",
            "borderRadius": "24px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "pillSecondary": {
        "defaultSize": {
          "defaultState": {
            "height": "16px",
            "width": "16px",
            "borderRadius": "16px",
            "backgroundColor": "#fff0eb",
            "paddingLeft": "0px",
            "paddingRight": "0px",
            "color": "#d23000",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "10px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.3px",
              "textTransform": "uppercase"
            }
          }
        }
      },
      "pillInactive": {
        "defaultSize": {
          "defaultState": {
            "height": "16px",
            "width": "16px",
            "borderRadius": "16px",
            "backgroundColor": "#e5e5e5",
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "10px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.3px",
              "textTransform": "uppercase"
            }
          }
        }
      }
    },
    "badgeIcon": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "height": "16px",
            "marginLeft": "-6px",
            "marginRight": "-6px",
            "marginTop": "-1px"
          }
        }
      }
    },
    "badgeIconBadge": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "height": "24px",
            "borderRadius": "24px"
          }
        }
      }
    },
    "button": {
      "defaultVariant": {
        "xsmall": {
          "defaultState": {
            "borderRadius": "4px",
            "padding": "5px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "14px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0px",
              "textTransform": "none"
            }
          }
        },
        "small": {
          "defaultState": {
            "borderRadius": "8px",
            "padding": "8px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "16px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0px",
              "textTransform": "none"
            }
          }
        },
        "medium": {
          "defaultState": {
            "borderRadius": "10px",
            "padding": "11px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "18px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.054px",
              "textTransform": "none"
            }
          }
        },
        "large": {
          "defaultState": {
            "borderRadius": "12px",
            "padding": "15px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "18px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.054px",
              "textTransform": "none"
            }
          }
        },
        "xlarge": {
          "defaultState": {
            "borderRadius": "46px",
            "padding": "22px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "20px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.35px",
              "textTransform": "none"
            }
          }
        }
      },
      "primary": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#ff4007",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "disabled": {
            "backgroundColor": "#ffbbad",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "hovered": {
            "backgroundColor": "#ff521f",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 6,
                "spread": 0,
                "blur": 8,
                "color": "rgba(0, 0, 0, 0.25)",
                "type": "dropShadow"
              }
            ]
          },
          "focused": {
            "backgroundColor": "#ff6436",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 6,
                "spread": 0,
                "blur": 8,
                "color": "rgba(0, 0, 0, 0.25)",
                "type": "dropShadow"
              }
            ]
          },
          "pressed": {
            "backgroundColor": "#e43500",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          }
        },
        "xsmall": {
          "defaultState": {
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "14px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0px",
              "textTransform": "none"
            }
          }
        },
        "small": {
          "defaultState": {
            "paddingTop": "6px",
            "paddingBottom": "7px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "19px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.057px",
              "textTransform": "none"
            }
          }
        },
        "medium": {
          "defaultState": {
            "paddingTop": "10px",
            "paddingBottom": "11px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "19px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.057px",
              "textTransform": "none"
            }
          }
        },
        "large": {
          "defaultState": {
            "paddingTop": "14px",
            "paddingBottom": "15px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "19px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.057px",
              "textTransform": "none"
            }
          }
        },
        "xlarge": {
          "defaultState": {
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "20px",
              "fontWeight": 700,
              "lineHeight": 1,
              "letterSpacing": "0.35px",
              "textTransform": "none"
            }
          }
        }
      },
      "secondary": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#000000",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "disabled": {
            "backgroundColor": "#e5e5e5",
            "color": "#b3b3b3",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "hovered": {
            "backgroundColor": "#323232",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 6,
                "spread": 0,
                "blur": 8,
                "color": "rgba(0, 0, 0, 0.25)",
                "type": "dropShadow"
              }
            ]
          },
          "focused": {
            "backgroundColor": "#575757",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 6,
                "spread": 0,
                "blur": 8,
                "color": "rgba(0, 0, 0, 0.25)",
                "type": "dropShadow"
              }
            ]
          },
          "pressed": {
            "backgroundColor": "#3c3c3c",
            "color": "#ffffff",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          }
        }
      },
      "secondaryOutlined": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "transparent",
            "borderColor": "#000000",
            "color": "#000000",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "disabled": {
            "backgroundColor": "transparent",
            "borderColor": "#b3b3b3",
            "color": "#b3b3b3",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "hovered": {
            "backgroundColor": "#ffffff",
            "borderColor": "#000000",
            "color": "#000000",
            "boxShadow": [
              {
                "x": 0,
                "y": 6,
                "spread": 0,
                "blur": 8,
                "color": "rgba(0, 0, 0, 0.25)",
                "type": "dropShadow"
              }
            ]
          },
          "focused": {
            "backgroundColor": "#e5e5e5",
            "color": "#000000",
            "boxShadow": [
              {
                "x": 0,
                "y": 6,
                "spread": 0,
                "blur": 8,
                "color": "rgba(0, 0, 0, 0.25)",
                "type": "dropShadow"
              }
            ]
          },
          "pressed": {
            "backgroundColor": "#e5e5e5",
            "borderColor": "#000000",
            "color": "#000000",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          }
        }
      },
      "text": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "transparent",
            "color": "#ff4007",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "disabled": {
            "backgroundColor": "transparent",
            "color": "#b3b3b3",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "hovered": {
            "backgroundColor": "#fff5f3",
            "color": "#d23000",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "focused": {
            "backgroundColor": "#fff0eb",
            "color": "#d23000",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          },
          "pressed": {
            "backgroundColor": "#ffe8e1",
            "color": "#d23000",
            "boxShadow": [
              {
                "x": 0,
                "y": 0,
                "spread": 0,
                "blur": 0,
                "color": "transparent",
                "type": "dropShadow"
              }
            ]
          }
        }
      },
      "textSecondary": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "transparent",
            "color": "#000000"
          },
          "disabled": {
            "backgroundColor": "transparent",
            "color": "#b3b3b3"
          },
          "hovered": {
            "backgroundColor": "#ffffff",
            "color": "#000000"
          },
          "focused": {
            "backgroundColor": "#e5e5e5",
            "color": "#000000"
          },
          "pressed": {
            "backgroundColor": "#e5e5e5",
            "color": "#000000"
          }
        }
      }
    },
    "toggleTrack": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#dee2ff"
          },
          "checked": {
            "backgroundColor": "#4200cf"
          },
          "disabledChecked": {
            "backgroundColor": "#b3b3b3"
          },
          "disabled": {
            "backgroundColor": "#e5e5e5"
          }
        }
      }
    },
    "toggleThumb": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#f8f8ff",
            "boxShadow": [
              {
                "x": 0,
                "y": 4,
                "spread": 0,
                "blur": 4,
                "color": "#CBC2FF",
                "type": "dropShadow"
              }
            ]
          },
          "hovered": {
            "backgroundColor": "#CBC2FF25"
          },
          "focused": {
            "backgroundColor": "#CBC2FF50"
          },
          "pressed": {
            "backgroundColor": "#CBC2FF50"
          },
          "disabled": {
            "backgroundColor": "#f9f9f9",
            "boxShadow": [
              {
                "x": 0,
                "y": 4,
                "spread": 0,
                "blur": 4,
                "color": "#E5E5E5",
                "type": "dropShadow"
              }
            ]
          }
        }
      }
    },
    "checkboxLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          }
        }
      }
    },
    "checkboxIcon": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "borderColor": "#808080"
          },
          "checked": {
            "backgroundColor": "#dee2ff",
            "color": "#4200cf"
          },
          "disabled": {
            "borderColor": "#b3b3b3",
            "backgroundColor": "#f9f9f9"
          },
          "disabledChecked": {
            "borderColor": "#f9f9f9",
            "backgroundColor": "#f9f9f9",
            "color": "#b3b3b3"
          }
        }
      }
    },
    "chip": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "borderRadius": "99px",
            "color": "red",
            "fill": "#4200cf",
            "height": "24px",
            "gap": "4px",
            "paddingTop": "0px",
            "paddingRight": "9px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "primary": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#dee2ff",
            "color": "#000000"
          }
        }
      },
      "secondary": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#f8f8ff",
            "color": "#000000"
          }
        }
      },
      "text": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "transparent",
            "color": "#000000"
          }
        }
      },
      "cornerLeft": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#dee2ff",
            "borderTopLeftRadius": "12px",
            "borderTopRightRadius": "0px",
            "borderBottomLeftRadius": "0px",
            "borderBottomRightRadius": "12px",
            "color": "#000000",
            "gap": "8px",
            "height": "30px",
            "paddingBottom": "7px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "paddingTop": "7px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "12px",
              "fontWeight": 700,
              "lineHeight": 1.3,
              "letterSpacing": "0.03px",
              "textTransform": "none"
            }
          }
        }
      },
      "cornerRight": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#dee2ff",
            "borderTopLeftRadius": "0px",
            "borderTopRightRadius": "12px",
            "borderBottomLeftRadius": "12px",
            "borderBottomRightRadius": "0px",
            "color": "#000000",
            "gap": "8px",
            "height": "30px",
            "paddingBottom": "7px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "paddingTop": "7px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "12px",
              "fontWeight": 700,
              "lineHeight": 1.3,
              "letterSpacing": "0.03px",
              "textTransform": "none"
            }
          }
        }
      },
      "selection": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#4200cf",
            "borderTopLeftRadius": "16px",
            "borderTopRightRadius": "16px",
            "borderBottomLeftRadius": "16px",
            "borderBottomRightRadius": "16px",
            "color": "#ffffff",
            "gap": "8px",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "14px",
            "paddingRight": "14px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.06px",
              "textTransform": "uppercase"
            }
          }
        }
      },
      "status": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#e5e5e5",
            "borderRadius": "8px",
            "color": "#000000",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "paddingRight": "8px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "statusPurple": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#dee2ff",
            "borderRadius": "8px",
            "color": "#000000",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "paddingRight": "8px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "statusGreen": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#cff0b2",
            "borderRadius": "8px",
            "color": "#000000",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "paddingRight": "8px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "statusBlue": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#d5f0ff",
            "borderRadius": "8px",
            "color": "#000000",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "paddingRight": "8px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "statusPink": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#ffe2dc",
            "borderRadius": "8px",
            "color": "#000000",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "paddingRight": "8px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "statusWhite": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#ffffff",
            "borderRadius": "8px",
            "color": "#000000",
            "height": "24px",
            "paddingBottom": "0px",
            "paddingLeft": "8px",
            "paddingRight": "8px",
            "paddingTop": "0px",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      },
      "category": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#ffffff",
            "border": {
              "color": "#e5e5e5",
              "width": "1.5px",
              "style": "solid"
            },
            "color": "#000000",
            "height": "40px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "16px",
              "fontWeight": 700,
              "lineHeight": 1.3,
              "letterSpacing": "0.03px",
              "textTransform": "none"
            }
          },
          "focused": {
            "borderColor": "#4200cf"
          },
          "hovered": {
            "backgroundColor": "#dee2ff",
            "borderColor": "#dee2ff"
          },
          "disabled": {
            "backgroundColor": "#f9f9f9",
            "borderColor": "#e5e5e5",
            "color": "#b3b3b3"
          }
        }
      },
      "categoryActive": {
        "defaultSize": {
          "defaultState": {
            "backgroundColor": "#dee2ff",
            "border": {
              "color": "#4200cf",
              "width": "1.5px",
              "style": "solid"
            },
            "color": "#000000",
            "height": "40px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "16px",
              "fontWeight": 700,
              "lineHeight": 1.3,
              "letterSpacing": "0.03px",
              "textTransform": "none"
            }
          },
          "hovered": {
            "backgroundColor": "#d5f0ff",
            "borderColor": "#000000"
          },
          "focused": {
            "borderColor": "#000000"
          }
        }
      }
    },
    "chipBadge": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "marginLeft": "24px"
          }
        }
      },
      "category": {
        "defaultSize": {
          "defaultState": {
            "marginLeft": "16px",
            "marginRight": "8px",
            "marginTop": "-2px"
          }
        }
      },
      "categoryActive": {
        "defaultSize": {
          "defaultState": {
            "marginLeft": "16px",
            "marginRight": "8px",
            "marginTop": "-2px"
          }
        }
      }
    },
    "chipIcon": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "fill": "#4200cf",
            "height": "16px"
          }
        }
      },
      "selection": {
        "defaultSize": {
          "defaultState": {
            "fill": "#ffffff",
            "height": "24px"
          },
          "hovered": {
            "fill": "#ffffff"
          }
        }
      }
    },
    "textField": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "paddingTop": "8px",
            "paddingBottom": "8px",
            "paddingLeft": "24px",
            "paddingRight": "24px",
            "backgroundColor": "#ffffff",
            "border": {
              "color": "#b3b3b3",
              "width": "1px",
              "style": "solid"
            },
            "borderRadius": "12px"
          },
          "disabled": {
            "backgroundColor": "#f9f9f9",
            "borderColor": "#b3b3b3"
          },
          "hovered": {
            "borderColor": "#000000"
          },
          "error": {
            "backgroundColor": "#fff5f3",
            "borderColor": "#bd0505"
          },
          "pressed": {
            "backgroundColor": "#ffffff",
            "borderColor": "#000000"
          }
        }
      }
    },
    "textFieldInput": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "disabled": {
            "color": "#b3b3b3"
          },
          "hovered": {
            "color": "#000000"
          },
          "error": {
            "color": "#000000"
          },
          "pressed": {
            "color": "#000000"
          }
        }
      },
      "textarea": {
        "defaultSize": {
          "defaultState": {
            "minHeight": "70px"
          }
        }
      }
    },
    "textFieldLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "disabled": {
            "color": "#b3b3b3"
          },
          "error": {
            "color": "#000000"
          },
          "pressed": {
            "color": "#6d6d6d",
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            }
          }
        }
      }
    },
    "textFieldAsterisk": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#d23000"
          },
          "disabled": {
            "color": "#b3b3b3"
          }
        }
      }
    },
    "radioButton": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "paddingTop": "8px",
            "paddingBottom": "8px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "backgroundColor": "transparent"
          },
          "defaultState:md": {
            "paddingTop": "4px",
            "paddingBottom": "4px",
            "paddingLeft": "0px",
            "paddingRight": "0px"
          }
        }
      },
      "outlined": {
        "defaultSize": {
          "defaultState": {
            "gap": "8px",
            "border": {
              "color": "#808080",
              "width": "1px",
              "style": "solid"
            },
            "borderRadius": "12px",
            "paddingTop": "16px",
            "paddingBottom": "16px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "backgroundColor": "transparent"
          },
          "checked": {
            "borderColor": "#4200cf",
            "backgroundColor": "#EFF1FF"
          },
          "disabled": {
            "borderColor": "#b3b3b3"
          },
          "disabledChecked": {
            "borderColor": "#9c8ef1",
            "backgroundColor": "#F8F8FF"
          }
        }
      }
    },
    "radioButtonLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "paddingLeft": "8px",
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          }
        }
      },
      "outlined": {
        "defaultSize": {
          "defaultState": {
            "paddingLeft": "8px",
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "disabled": {
            "color": "#b3b3b3"
          }
        }
      }
    },
    "radioButtonIcon": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#808080",
            "width": "16px",
            "height": "16px"
          },
          "checked": {
            "color": "#000000"
          },
          "disabled": {
            "color": "#b3b3b3"
          }
        }
      },
      "outlined": {
        "defaultSize": {
          "defaultState": {
            "color": "#808080",
            "width": "16px",
            "height": "16px"
          },
          "checked": {
            "color": "#000000"
          },
          "disabled": {
            "color": "#b3b3b3"
          }
        }
      }
    },
    "select": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "minWidth": "318px",
            "paddingTop": "8px",
            "paddingBottom": "8px",
            "paddingLeft": "24px",
            "paddingRight": "24px",
            "backgroundColor": "#ffffff",
            "border": {
              "color": "#b3b3b3",
              "width": "1px",
              "style": "solid"
            },
            "borderRadius": "12px"
          },
          "disabled": {
            "backgroundColor": "#f9f9f9",
            "borderColor": "#b3b3b3"
          },
          "hovered": {
            "borderColor": "#000000"
          },
          "error": {
            "backgroundColor": "#fff5f3",
            "borderColor": "#000000"
          },
          "pressed": {
            "backgroundColor": "#ffffff",
            "borderColor": "#000000"
          }
        }
      }
    },
    "selectIcon": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "width": "24px",
            "height": "24px"
          }
        }
      }
    },
    "dropdownMenu": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "paddingTop": "16px",
            "paddingBottom": "16px",
            "boxShadow": [
              {
                "x": 0,
                "y": 5,
                "spread": 0,
                "blur": 30,
                "color": "rgba(0, 0, 0, 0.13)",
                "type": "dropShadow"
              }
            ]
          }
        }
      }
    },
    "dropdownMenuItem": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "paddingTop": "16px",
            "paddingBottom": "16px",
            "paddingLeft": "24px",
            "paddingRight": "24px",
            "color": "#4d4d4d",
            "backgroundColor": "#ffffff",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "hovered": {
            "backgroundColor": "#f9f9f9"
          },
          "pressed": {
            "backgroundColor": "#f9f9f9"
          },
          "selected": {
            "backgroundColor": "#f8f8ff"
          }
        }
      }
    },
    "formHelperText": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "typography": {
              "fontFamily": "DMSans-Medium, sans-serif",
              "fontSize": "12px",
              "fontWeight": 500,
              "lineHeight": 1.3,
              "letterSpacing": "0.15px",
              "textTransform": "none"
            },
            "color": "#6d6d6d"
          },
          "disabled": {
            "color": "#b3b3b3"
          },
          "error": {
            "color": "#bd0505"
          },
          "pressed": {
            "color": "#6d6d6d"
          }
        }
      }
    },
    "formLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            },
            "color": "#000000"
          },
          "error": {
            "color": "#d23000"
          },
          "disabled": {
            "color": "#b3b3b3"
          }
        }
      }
    },
    "formLabelAsterisk": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#d23000"
          },
          "error": {
            "color": "#d23000"
          },
          "disabled": {
            "color": "#b3b3b3"
          }
        }
      }
    },
    "dateSelectorSelectDateLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#808080"
          }
        }
      }
    },
    "dateSelectorYearLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Bold, sans-serif",
              "fontSize": "16px",
              "fontWeight": 700,
              "lineHeight": 1.3,
              "letterSpacing": "0.03px",
              "textTransform": "none"
            }
          }
        }
      }
    },
    "dateSelectorWeekdayLabel": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#808080",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "12px",
              "fontWeight": 700,
              "lineHeight": 1.2,
              "letterSpacing": "0.15px",
              "textTransform": "uppercase"
            }
          }
        }
      }
    },
    "dateSelectorYearButton": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "hovered": {
            "backgroundColor": "transparent",
            "border": {
              "style": "solid",
              "width": "1px",
              "color": "#212962"
            }
          },
          "selected": {
            "backgroundColor": "#4200cf",
            "color": "#ffffff"
          }
        }
      }
    },
    "dateSelectorDayButton": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "color": "#000000",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "hovered": {
            "color": "#000000",
            "border": {
              "style": "solid",
              "width": "1px",
              "color": "#212962"
            }
          },
          "selected": {
            "backgroundColor": "#4200cf",
            "color": "#ffffff"
          },
          "currentDate": {
            "backgroundColor": "#eff1ff",
            "color": "#000000"
          }
        }
      }
    },
    "toggleButton": {
      "defaultVariant": {
        "defaultSize": {
          "defaultState": {
            "border": {
              "style": "solid",
              "width": "1.5px",
              "color": "#e5e5e5"
            },
            "backgroundColor": "#ffffff",
            "color": "#000000",
            "height": "40px",
            "paddingLeft": "16px",
            "paddingRight": "16px",
            "typography": {
              "fontFamily": "DMSans-Regular, sans-serif",
              "fontSize": "16px",
              "fontWeight": 400,
              "lineHeight": 1.4,
              "letterSpacing": "0.8px",
              "textTransform": "none"
            }
          },
          "disabled": {
            "backgroundColor": "#f9f9f9",
            "color": "#b3b3b3",
            "borderColor": "#e5e5e5"
          },
          "hovered": {
            "backgroundColor": "#dee2ff"
          },
          "active": {
            "backgroundColor": "#dee2ff",
            "color": "#4200cf",
            "borderColor": "#4200cf"
          }
        }
      }
    }
  }
};
var nomad_spark_default = theme;
/*! Generated by 🖌️ Theme Builder on Fri, 06 Oct 2023 15:20:02 GMT */
/*! See: https://github.com/NomadHealth/design-system/blob/main/theme-builder/README.md */
